export default "__VITE_ASSET__Dlav0Dto__"